export default {
  enums: {
    valid: '有效',
    invalid: '失效',
    enable: '启用',
    disabled: '禁用',
    saved: '已保存',
    confirmed: '业务已确认',
    confirm: '已确认',
    reverted: '已撤销',
    priced: '已定价',
    notPriced: '未定价',
    writeOffWith: '已冲销',
    beingWrittenOff: '冲销中',
  },
};
